'use client';

import { Card, CssProps } from '@nettbureau/vibrant-ui';
import { ReactNode } from 'react';

type FeaturedCardProps = {
  children?: ReactNode;
  border?: boolean;
  minHeight?: number;
} & CssProps;

export function FeaturedCard({
  children,
  className,
  minHeight,
}: FeaturedCardProps) {
  return (
    <Card
      width={75}
      height={minHeight}
      borderRadius="2xl"
      className={className}
      shadow="medium"
    >
      {children}
    </Card>
  );
}
